import { createModel, RematchDispatch } from '@rematch/core';
import * as draftTourService from '../../services/draftTour.service';
import { PaginationType } from '../../types/CommonTypes';
import { TourData } from '../../types/TourData';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'draftTourEntity';

export const draftTourEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof draftTourEntity>) => ({
    async loadDraftTourById(id, state): Promise<TourData> {
      try {
        const res = await draftTourService.getTour(id);
        const tour = res.data;
        if (tour) {
          this.saves([tour]);
        }
        return tour;
      } catch (e) {
        throw new Error(e);
      }
    },
    async loadDraftTours(params): Promise<{ content?: TourData[] } & PaginationType> {
      try {
        const res = await draftTourService.getTours({ params });
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async saveDraft(payload) {
      try {
        if (!payload.id) {
          await draftTourService.createTour(payload);
        } else {
          await draftTourService.updateTour(payload.id, payload);
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    async deleteDraft(id) {
      try {
        const res = await draftTourService.deleteTour(id);
        if (res && res.data) {
          this.remove({ id });
        }
        return res;
      } catch (e) {
        throw new Error(e);
      }
    },
    async makeScenesForMarkers(payload) {
      try {
        await draftTourService.makeScenes(payload.tourId, payload);
      } catch (e) {
        throw new Error(e);
      }
    },
    async makeTour(payload) {
      try {
        const { data: result } = await draftTourService.makeTour(payload);
        if (result) {
          this.remove({ payload });
        }

        return result;
      } catch (e) {
        throw new Error(e);
      }
    },
    async updateState(payload) {
      try {
        await draftTourService.updateState(payload.id, payload);
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default draftTourEntity;
